module.exports = __webpack_public_path__ + "static/media/sample_4-05.e10607fc.jpg";